module.exports = __webpack_public_path__ + "cf3d12cd419269cf13d5e527d36c24a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/normal-s.png
// module id = 1788
// module chunks = 0